export default {
  screens: [
    {
      type: 'intro',
      title: 'Nature',
      content:
        'An inexhaustible source of inspiration, nature, both abundant and symbolic, is a major theme in the history of the Maison.',
      idYt: 'GUF98BCNd3c',
      videoCover: 'world/wild/video.jpg',
      desktop: {
        cover: 'world/wild/cover-1.jpg'
      },
      mobile: {
        cover: 'world/wild/mobile-cover-1.jpg',
        contentStyle: { width: '100%', paddingBottom: '120px' },
        coverStyle: {
          width: '110%',
          top: '87%',
          bottom: '40px',
          left: '0',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/wild/memento.jpg',
      content:
        ' Fauna, flora and insects turned into jewels by master craftsmen relate wild, lively and graceful nature.<br><br>Rich in references, the botanical repertoire of Chaumet is a choice of distinction.',
      cover: 'world/wild/cover-2.jpg',
      isCover: true
    },
    {
      type: 'staircase',
      desktop: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/cover-3.jpg'
      },
      mobile: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/mobile-cover-3.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '85%',
          top: '-15%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        "Wheat, Joséphine's choice, is the symbol of abundance bending in the wind from its inception.<br><br>Chaumet continues to revisit this motif like the Wheat Sheaf tiara of 1811.",
      isCover: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/en/worlds/wild.js